module.exports = __webpack_public_path__ + "img/borderFormWhite.2f5f2d47.svg";